import type { GiftResult, Takings, VisitorGame } from '@goodtime/shared';
import { api } from './client';

/** Open a gift the showrunner left (a mystery box, a rival's gift, the
 *  treasure map's chest); free spins in it go to this session. The key is
 *  the same on every retry, and the server pays a gift once however often
 *  it's asked. */
export function acceptGift(playId: string, sessionId: string): Promise<GiftResult> {
  return api<GiftResult>(`/plays/${encodeURIComponent(playId)}/accept`, {
    method: 'POST',
    headers: { 'Idempotency-Key': `${playId}-accept` },
    body: JSON.stringify({ sessionId }),
  });
}

/** Take up a visitor's game, or the treasure map's dig: the server opens it
 *  and hands back its offer, to play through `/plays/{id}/act`. Safe to
 *  retry. (A visitor sent on their way uses `declinePlay`.) */
export function acceptVisitor(playId: string, sessionId: string): Promise<VisitorGame> {
  return api<VisitorGame>(`/plays/${encodeURIComponent(playId)}/accept`, {
    method: 'POST',
    headers: { 'Idempotency-Key': `${playId}-accept` },
    body: JSON.stringify({ sessionId }),
  });
}

/** What the player won since `since` (epoch ms), for the takings card;
 *  null when it can't be fetched (the card is skipped). */
export async function fetchTakings(playerId: string, since: number): Promise<Takings | null> {
  try {
    return await api<Takings>(`/players/${encodeURIComponent(playerId)}/takings?since=${Math.floor(since)}`);
  } catch {
    return null;
  }
}
